/** @jsx jsx */
import { useEffect } from "react"
import { useGlobalState } from "../utils/globalState"

export function ActivityHeartbeat() {
  const globalState = useGlobalState()

  useEffect(() => {
    const tick = async () => {
      console.log("ActivityHeartbeat")

      const userId = globalState.user.id
      try {
        await window.skeem.mutate({
          skeem_users: {
            update: {
              id: userId,
              lastActivityAt: new Date(),
            },
          },
        })
      } catch (e) {
        // Intentionally swallow errors to avoid user disruption
        // This is a best-effort background update
        console.warn("ActivityHeartbeat error", e)
      }
    }

    tick()
    const interval = setInterval(tick, 5 * 60 * 1000)
    return () => clearInterval(interval)
  }, [])

  return null
}
